import React, { Component } from 'react';
import Text from '@dbk/ui-text';
import DisplayTime from './get-display-time';
import SentAttach from './sent-attach';

class SentMessage extends Component {

  render = () => (
    this.props.message.attachmentId ?
      <SentAttach message={this.props.message}
      downloadAttachment={this.props.downloadAttachment}
      isDownloading={this.props.isDownloading}/> :

      <div className="speech-bubble">
        <Text size="normal" secondary>{this.props.message.message ? this.props.message.message : ''}</Text>
        <div className="timestamp">
          <DisplayTime
            dateAndTime={this.props.message.meta} /></div>
      </div>
  )


}
export default SentMessage;
